import React, { useEffect, useState } from "react";
import { Backdrop, Button, CircularProgress, FormControl, Grid, Tooltip } from "@mui/material";
import CommonDatePicker from "../../../../Base/views/CommonDatePicker";
import CommonDateTimePicker from "../../../../Base/views/CommonDateTimePicker";
import {
  DateConvertInDbFormat,
  getEmployeeId,
} from "../../../../Base/helper/baseFunctions";
import { GetAutofillAttendanceRegularizationHelper } from "../../../helper/Team/RegularizationHelper";
import { createStyles, makeStyles } from "@mui/styles";
import SelectableSearch from "../../../../Base/views/SelectableSearch";
import { GetEmployeesHelper } from "../../../../Employee/helper/EmployeeHelper";
import { useSelector } from "react-redux";

const RaiseRegularizationPopup = ({
  editedRecord,
  addMode,
  setOpenPopup,
  onSubmit,
  startOfMonth,
  endOfMonth,
  team= false
}) => {
  const useStyles = makeStyles((theme) =>
    createStyles({
      Backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: "rgba(255, 255, 255, 0.5)",
        position: "absolute",
        borderRadius: "inherit",
      },
    }),
  );
  const classes = useStyles();
  const [formData, setFormData] = useState({
    record_date: team ? null : DateConvertInDbFormat(startOfMonth),
    check_in_time: null,
    check_out_time: null,
    attendance_regularisation_pk: null,
    status: "Submitted",
    employee_id: ""
  });
  const [employeesData, setEmployeesData] = useState({
      load: true,
      values: [],
    });
  const [errors, setErrors] = useState({});
  const [isChecking, setIsChecking] = useState(false);
    const { minDojYear } = useSelector(
        (state) => state?.AncillaryReducer?.WorkSpaceDojReducer,
    );
  const getDefaultWorkTimes = (date) => {
    const baseDate = date ? new Date(date) : new Date();
    const checkIn = new Date(baseDate);
    checkIn.setHours(9, 0, 0, 0);
    const checkOut = new Date(baseDate);
    checkOut.setHours(18, 0, 0, 0);
    return { checkIn, checkOut };
  };

  const checkDate = async () => {
    setFormData({
      ...formData,
      record_date: team ? null : DateConvertInDbFormat(startOfMonth),
      attendance_regularisation_pk: null,
      status: "Submitted",
    });
    if (!team) {
        setIsChecking(true);
        const resData = await GetAutofillAttendanceRegularizationHelper({
          employee_fk: getEmployeeId(),
          date: DateConvertInDbFormat(startOfMonth ?? new Date()),
        });
        if (resData?.data?.statuscode === 200) {
          const autoDate = resData?.data?.data;
          if (autoDate?.length && autoDate?.length > 0) {
            const autoDate0 = autoDate[0];
            setFormData({
              ...formData,
              check_in_time: UTCToPickerDate(autoDate0?.in_time),
              check_out_time: UTCToPickerDate(autoDate0?.out_time),
            });
          } else {
            const { checkIn, checkOut } = getDefaultWorkTimes(startOfMonth ?? new Date());
            setFormData({ ...formData, check_in_time: checkIn, check_out_time: checkOut });
          }
        } else {
          const { checkIn, checkOut } = getDefaultWorkTimes(startOfMonth ?? new Date());
          setFormData({ ...formData, check_in_time: checkIn, check_out_time: checkOut });
        }
        setIsChecking(false);
    }
  };
  useEffect(() => {
    if (editedRecord && addMode) {
      const parsedInTime = parseDateValue(
        editedRecord.check_in_time ?? editedRecord.in_time,
      );
      const parsedOutTime = parseDateValue(
        editedRecord.check_out_time ?? editedRecord.out_time,
      );
      const { checkIn: defaultCheckIn, checkOut: defaultCheckOut } = getDefaultWorkTimes(editedRecord.record_date);

      setFormData({
        record_date: editedRecord.record_date,
        check_in_time: parsedInTime ?? defaultCheckIn,
        check_out_time: parsedOutTime ?? defaultCheckOut,
        attendance_regularisation_pk:
          editedRecord.attendance_regularisation_pk ?? null,
        status: editedRecord.status || "Submitted",
      });
    } else {
      checkDate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editedRecord, addMode]);


const parseDateValue = (value) => {
  if (!value) return null;

  return value instanceof Date
    ? value
    : UTCToPickerDate(value);
};
  const handleInputChange = async (event, value) => {
    if (["record_date"].includes(event)) {
        setIsChecking(true);
      const resData = await GetAutofillAttendanceRegularizationHelper({
        employee_fk: team ? formData?.employee_id?.employee_id : getEmployeeId(),
        date: DateConvertInDbFormat(value),
      });
      if (resData?.data?.statuscode === 200) {
        const autoDate = resData?.data?.data;
        if (autoDate?.length && autoDate?.length > 0) {
          const autoDate0 = autoDate[0];
          setFormData({
            ...formData,
            [event]: value,
            check_in_time: autoDate0?.in_time
              ? parseDateValue(autoDate0?.in_time)
              : null,
            check_out_time: autoDate0?.out_time
              ? parseDateValue(autoDate0?.out_time)
              : null,
          });
        } else {
          const { checkIn, checkOut } = getDefaultWorkTimes(value);
          setFormData({
            ...formData,
            [event]: value,
            check_in_time: checkIn,
            check_out_time: checkOut,
          });
        }
      } else {
        const { checkIn, checkOut } = getDefaultWorkTimes(value);
        setFormData({
          ...formData,
          [event]: value,
          check_in_time: checkIn,
          check_out_time: checkOut,
        });
      }
      setIsChecking(false);
      Object.values?.(errors)?.some((res) => res !== "") &&
        validate({ ...formData, [event]: value });
    } else {
      setFormData({ ...formData, [event]: value,
        ...(event === "employee_id" && {
          record_date: null,
          check_in_time: null,
          check_out_time: null,
        })
       });
      Object.values?.(errors)?.some((res) => res !== "") &&
        validate({ ...formData, [event]: value });
    }
  };

  const validate = (fieldValues) => {
    let validationErrors = { ...errors };

    if ("record_date" in fieldValues) {
      validationErrors.record_date = !fieldValues.record_date
        ? "Record date is required"
        : "";
    }
    if ("check_in_time" in fieldValues) {
      validationErrors.check_in_time = !fieldValues.check_in_time
        ? "Check-in time is required"
        : "";
    }
    if ("check_out_time" in fieldValues) {
      validationErrors.check_out_time = !fieldValues.check_out_time
        ? "Check-out time is required"
        : "";
    }

    const checkInValue = fieldValues.check_in_time;
    const checkOutValue = fieldValues.check_out_time;
    if (checkInValue && checkOutValue) {
      if (new Date(checkOutValue).getTime() <= new Date(checkInValue).getTime()) {
        validationErrors.check_out_time =
          "Check-out time must be later than check-in time";
      } else {
        validationErrors.check_out_time = ""
      }
    }

    if ("employee_id" in fieldValues && team) {
      validationErrors.employee_id =
        !fieldValues.employee_id ? "Employee is required"
          : "";
    } else {
        validationErrors.employee_id = ""
    }
    setErrors({
      ...validationErrors,
    });
    return Object.values(validationErrors).every((x) => x === "");
  };

  const handleSubmit = () => {
    if (!validate(formData)) return;
    const payload = {
      ...formData,
    };
    onSubmit?.(payload);
    setOpenPopup(false);
  };

  const handleEmployees = () => {
    GetEmployeesHelper({ is_active: true }).then((res) => {
        if(res?.data?.statuscode === 200) {
            const emp_options = res?.data?.data
            setEmployeesData({ load: false, values: emp_options });
        } else {
            setEmployeesData({ load: false, values: [] });
        }
    })
  };

  const recordDate = formData?.record_date
    ? new Date(formData?.record_date)
    : new Date();
  const maxDate = new Date(recordDate);
  maxDate.setDate(maxDate.getDate() + 1);

  const minDate = team ? new Date(new Date(minDojYear).setFullYear(new Date(minDojYear).getFullYear() - 1)) : startOfMonth;
  const endDate = team ?  new Date(new Date().getFullYear(),new Date().getMonth() + 1, 0) : endOfMonth;         
  return (
    <Grid container spacing={2} sx={{position: "relative"}}>
        <Backdrop
            className={classes.Backdrop}
            open={isChecking} 
            >
            <CircularProgress />
        </Backdrop>
      {team && <Grid item xs={12} md={6}>
        <FormControl fullWidth>
            <SelectableSearch
                label="Employee"
                value={formData?.employee_id}
                loading={() => handleEmployees()}
                fieldLabel="name"
                required={true}
                variant={"outlined"}
                name="employee_id"
                size="small"
                onChangeEvent={handleInputChange}
                data={employeesData}
                {...(errors.employee_id && {
                    error: true,
                    helperText: errors.employee_id,
                })}
            />
        </FormControl>
      </Grid>}
      <Grid item xs={12} md={team ? 6 : 12}>
        <Tooltip
            title={(!formData?.employee_id && team) ? "Please select an employee first" : ""}
            arrow
        >
            <span>
                <FormControl fullWidth>
                <CommonDatePicker
                    disabled={!!editedRecord || (!formData?.employee_id && team)}
                    name="record_date"
                    openTo="day"
                    views={["year", "month", "day"]}
                    label="Attendance Date"
                    pickerType="date"
                    size="small"
                    onKeyDown={(e) => e.preventDefault()}
                    onKeyPress={(e) => e.preventDefault()}
                    pickerFormat="dd/MM/yyyy"
                    DefaultDTvalue={formData.record_date}
                    minDate={minDate}
                    maxDate={endDate}
                    handleChange={(value) => handleInputChange("record_date", value)}
                    error={!!errors.record_date}
                    helperText={errors.record_date}
                />
                </FormControl>
            </span>
        </Tooltip>
      </Grid>
      <Grid item xs={12} md={6}>
        <FormControl fullWidth>
          <CommonDateTimePicker
            name="check_in_time"
            size="small"
            label="Check-In Time"
            pickerFormat="dd/MM/yyyy hh:mm aa"
            DefaultDTvalue={formData.check_in_time}
            handleChange={(value) => handleInputChange("check_in_time", value)}
            openTo="hours"
            views={["hours", "minutes"]}
            error={!!errors.check_in_time}
            helperText={errors.check_in_time}
            minDate={recordDate}
            maxDate={recordDate}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} md={6}>
        <FormControl fullWidth>
          <CommonDateTimePicker
            name="check_out_time"
            size="small"
            label="Check-Out Time"
            pickerFormat="dd/MM/yyyy hh:mm aa"
            DefaultDTvalue={formData.check_out_time}
            handleChange={(value) => handleInputChange("check_out_time", value)}
            views={["year", "month", "day", "hours", "minutes"]}
            error={!!errors.check_out_time}
            helperText={errors.check_out_time}
            minDate={recordDate}
            maxDate={maxDate}
          />
        </FormControl>
      </Grid>
      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 1 }}
      >
        <Button variant="outlined" onClick={() => setOpenPopup(false)}>
          Cancel
        </Button>
        <Button
          variant="contained"
          className="mpl-primary-btn"
          onClick={handleSubmit}
        >
          {!editedRecord ? "Save" : "Update"}
        </Button>
      </Grid>
    </Grid>
  );
};

const UTCToPickerDate = (utcDateString) => {
  if (!utcDateString) return null;

  const utcDate = new Date(utcDateString);

  return new Date(
    utcDate.getUTCFullYear(),
    utcDate.getUTCMonth(),
    utcDate.getUTCDate(),
    utcDate.getUTCHours(),
    utcDate.getUTCMinutes(),
    utcDate.getUTCSeconds(),
    utcDate.getUTCMilliseconds()
  );
};

export default RaiseRegularizationPopup;
